<template>
  <div class="page-container">
    <div class="page-container" v-if="$root.layout.ready">
      <div class="page-container" v-if="$root.auth.isLogin">
        <left-side></left-side>
        <div class="right-side" :class="{'collapse-right':$root.layout.sideBarCollapse}"
             v-loading="$root.loading">
          <content-header></content-header>
          <div class="inside">
            <router-view class="view" :key="$route.path"></router-view>
          </div>
          <div class="loading-bar" v-if="$root.loading">
            <div class="spinner">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="auth-layout" v-if="!$root.auth.isLogin">
      <router-view class="view"></router-view>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'App',
    data() {
      return {
        show: false
      }
    },
    created() {

    },
    computed: {}
  }
</script>

<style lang="scss">
  @import "sass/index.scss";
</style>



// WEBPACK FOOTER //
// src/App.vue